const library_en = require('./library.json')
export default library_en